import { themeColors } from "../../../themeColors";
/**
 * @file   src\mobile\components\SendIntroduction\CustomizeIntro.js
 * @brief  This file is responsible for customize introduction
 * @date   May, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import React, { useState, useEffect } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import QuestionIcon from "../../components/QuestionIcon";
import "../../styles/clients.scss";
import noImage from "../../../images/no-image-placeholder.png";
import PreviewIntroductionOffcanvas from "./v2/PreviewIntroductionOffcanvas";
import { setBodyBackgroundWhite } from "../../../helpers/common";
import { REORDER_N2H, REORDER_PHOTOS } from "../../../constants/onBoarding";
import TopHeader from "../common/TopHeader";
import BackLinkButton from "../../components/BackLinkButton";
import { usePremium } from "@/hooks";

const CustomizeIntro = (props) => {
  useEffect(() => {
    setBodyBackgroundWhite();
    document.body.classList.add("bg-offcanvas-fix");
  }, []);
  const { selectedProperty, handleBackButtonClick } = props;
  const propertyFeatures = selectedProperty?.propertyFeaturesForPreview;
  const inventoryPhotos = selectedProperty?.photosForPreview;
  const [coverPhotos, setCoverPhotos] = useState([]);

  const [showPreviewIntroduction, setShowPreviewIntroduction] = useState(false);
  const PreviewIntroductionClose = () => setShowPreviewIntroduction(false);
  const PreviewIntroductionShow = () => setShowPreviewIntroduction(true);

  const { shouldToggleColor } = usePremium();

  useEffect(() => {
    if (inventoryPhotos && inventoryPhotos.length > 0) {
      const defaultArray = inventoryPhotos?.filter((item) => item.isCover == 1);
      setCoverPhotos(defaultArray);
    } else {
      setCoverPhotos([]);
    }
  }, [inventoryPhotos]);

  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Pick up to 3 photos to show buyers in your introduction. Once accepted,
      they can view all your property photos.
    </Tooltip>
  );

  const renderTooltipForPropertyFeature = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Change the order of your property features to highlight what's most
      important for this want listing.
    </Tooltip>
  );
  return (
    <div className="gitcha-main-wrapper view-client-wrap intro-checkout-wrap bg-white">
      <div className="content-wrapper content-wrapper-h-102-percent">
        <TopHeader
          variant="review"
          outerClassname="bg-white"
          topClassName="header-brdr-btm w-100"
          bottomClassName="signup-header-txt clearfix"
        >
          <BackLinkButton
            variant="small"
            shouldToggleColor={shouldToggleColor}
            onClick={() => {
              handleBackButtonClick();
            }}
          />
          <span className={shouldToggleColor ? "heading-premium" : "heading"}>
            Customize Intro
          </span>
        </TopHeader>
        <div className="inner-layout-content-new">
          <div className="payment-method-wrap intro-summary-sec">
            <div className="title-group d-flex align-items-center">
              <div className="title-block">
                <h4>Introduction Photos</h4>
                <OverlayTrigger
                  placement="bottom"
                  delay={{ show: 250, hide: 400 }}
                  overlay={renderTooltip}
                >
                  <a href={void 0} className="tooltip-icon">
                    <QuestionIcon />
                  </a>
                </OverlayTrigger>
              </div>
              <button
                type="button"
                className="btn btn-link"
                onClick={() => {
                  props.setUIKey(REORDER_PHOTOS);
                }}
              >
                Edit
              </button>
            </div>
            <div className="inventory-banner-small position-relative">
              <div className="banner-row">
                {coverPhotos.length == 0 ? (
                  <div className="banner-column-full banner-single h-200">
                    <div className="full-col-img-wrap h-100">
                      <img
                        className="brdr-top-10 col-img-style"
                        src={noImage}
                        alt=""
                      />
                    </div>
                  </div>
                ) : (
                  coverPhotos && (
                    <>
                      {coverPhotos.length == 1 && (
                        <div className="banner-column-full banner-single h-200">
                          <div className="full-col-img-wrap h-100">
                            <div className="upload-cover-btn-mob">Cover</div>
                            <img
                              className="brdr-top-10 col-img-style"
                              src={coverPhotos[0]?.image}
                              alt=""
                            />
                          </div>
                        </div>
                      )}
                      {coverPhotos.length == 2 && (
                        <>
                          <div className="banner-column-full h-200">
                            <div className="full-col-img-wrap h-100">
                              <div className="upload-cover-btn-mob">Cover</div>
                              <img
                                className="brdr-top-10 col-img-style"
                                src={coverPhotos[0]?.image}
                                alt=""
                              />
                            </div>
                          </div>

                          <div className="banner-column-full h-200">
                            <div className="full-col-img-wrap h-100">
                              <div className="upload-cover-btn-mob">Cover</div>
                              <img
                                className="brdr-top-10 col-img-style"
                                src={coverPhotos[1]?.image}
                                alt=""
                              />
                            </div>
                          </div>
                        </>
                      )}
                      {coverPhotos.length >= 3 && (
                        <>
                          <div className="banner-column-full h-200">
                            <div className="full-col-img-wrap h-100">
                              <div className="upload-cover-btn-mob">Cover</div>
                              <img
                                className="brdr-top-10 col-img-style"
                                src={coverPhotos[0]?.image}
                                alt=""
                              />
                            </div>
                          </div>

                          <div className="banner-column-full d-flex h-148">
                            {coverPhotos[1]?.image && (
                              <div className="quarter-col-img-wrap-left w-50-percent">
                                <img
                                  className="brdr-btm-left-10 col-img-style"
                                  src={coverPhotos[1]?.image}
                                  alt=""
                                />
                              </div>
                            )}
                            {coverPhotos[2]?.image && (
                              <div className="quarter-col-img-wrap-right w-50-percent">
                                <img
                                  className="brdr-btm-right-10 col-img-style"
                                  src={coverPhotos[2]?.image}
                                  alt=""
                                />
                              </div>
                            )}
                          </div>
                        </>
                      )}
                    </>
                  )
                )}
              </div>
            </div>
          </div>
          {propertyFeatures.length > 0 && (
            <div className="payment-method-wrap">
              <div className="title-group d-flex align-items-center">
                <div className="title-block">
                  <h4>Property Features</h4>
                  <OverlayTrigger
                    placement="bottom"
                    overlay={renderTooltipForPropertyFeature}
                  >
                    <a href={void 0} className="tooltip-icon">
                      <QuestionIcon />
                    </a>
                  </OverlayTrigger>
                </div>
                <button
                  type="button"
                  className="btn btn-link"
                  onClick={() => {
                    props.setUIKey(REORDER_N2H);
                  }}
                >
                  Reorder
                </button>
              </div>
              <div className="feature-list">
                {propertyFeatures
                  .sort((a, b) => a.order - b.order)
                  .map((feature, index) => {
                    return (
                      <div className="info-pill">
                        <div className="feature-icon">
                          {" "}
                          <img
                            src={
                              feature?.icon
                                ? require("../../../images/" + feature?.icon)
                                : ""
                            }
                            alt=""
                          />
                        </div>
                        <p className="m-0">{feature?.text}</p>
                      </div>
                    );
                  })}
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="inner-layout-footer-new">
        <div className="inner-btm-fixed-nav">
          <div className="btn-wrap">
            <button
              type="button"
              className="btn btn-primary w-100"
              onClick={() => {
                props.saveCustomizeData();
              }}
            >
              Save Changes
            </button>
            <button
              type="button"
              className="btn btn-link w-100"
              onClick={PreviewIntroductionShow}
            >
              Preview Introduction
            </button>
          </div>
          <PreviewIntroductionOffcanvas
            show={showPreviewIntroduction}
            onHide={PreviewIntroductionClose}
            selectedProperty={selectedProperty}
          />
        </div>
      </div>
    </div>
  );
};

export default CustomizeIntro;
